import React, { useContext } from 'react';
import { CombinePortfoliosWizardContext } from './logic/CombinePortfoliosWizardContext';
import { ShimmerBlock } from 'venn-ui-kit';
import { cn } from '@/lib/utils';
import { OwnershipContextSelector } from 'venn-components';

export const OwnershipStep = () => {
  const context = useContext(CombinePortfoliosWizardContext);

  if (context.portfoliosLoading) {
    return <ShimmerBlock />;
  }

  return (
    <div className={cn('flex flex-col pl-[32px] pr-[24px] py-[40px] gap-[24px]')}>
      {context.portfolios.map((portfolio) => (
        <div key={portfolio.name} className={cn('flex flex-col gap-[4px]')}>
          <label className={cn('font-[14px]')}>{portfolio.name}</label>
          <OwnershipContextSelector
            ownerContextId={context.ownershipSettings[portfolio.name]}
            setOwnerContextId={(id) =>
              context.setOwnershipSettings((current) => ({ ...current, [portfolio.name]: id }))
            }
            requiredAction="CREATE_PORTFOLIO"
            refreshedStyling
            className={cn('mt-0')}
          />
        </div>
      ))}
    </div>
  );
};
